import * as Strings from '../constants/strings';
import * as ErrorCodes from '../constants/errorCodes';
import {
  USERNAME_PASSWORD, USERNAME_PASSWORD_WEBSSO, SMS_ENROLL_VERIFY, IID_ENROLL, IID_PUSH, CHANGE_PASSWORD, SECOND_FACTOR, SELF_SERVICE_START, SELF_SERVICE_ENROLL, SELF_SERVICE_END
} from '../constants/contexts';
import { GetMessageProtocols } from '../constants/clientProtocols';

function logError(message) {
  console.log('%c' + message, 'color: #f4a142');   // eslint-disable-line
}

export default function getErrorMessage(errorCode, contextPage, serialNumber) {
  // Web SSO username-screen return: emit byte-identical generic error for
  // every reachable failure code so unknown-user, wrong-password, and other
  // server-reported failures are indistinguishable to the user.
  if (contextPage === USERNAME_PASSWORD_WEBSSO && errorCode !== null && errorCode !== undefined) {
    return [Strings.SECOND_FACTOR_INVALID,];
  }
  const {
    GetMsgInvalidCredentials,
    GetMsgModalityNotEnrolled,
    GetMsgModalityNotAllowed,
    GetMsgUserDisabled,
    GetMsgUserExpired,
    GetMsgUserLocked,
    GetMsgUsernameNotUnique,
    GetMsgUserNotFound,
    GetMsgInvalidPhoneNumber,
    GetMsgInvalidImprivataIdSerialNumber,
    GetMsgApplianceNotConnected,
    GetMsgInternalError,
    GetMsgWorkflowNotAssigned,
    GetMsgWorkflowNotEnabled,
    GetMsgWorkflowNotAllowed,
  } = GetMessageProtocols;
  let errors;
  switch (errorCode) {
  case GetMsgInvalidCredentials.asString:
    // logError('Underlying error: InvalidCredentials');
    switch (contextPage) {
    case SMS_ENROLL_VERIFY:
      errors = [Strings.INVALID_PHONE_VERIFICATION,];
      break;
    case IID_ENROLL:
      errors = [Strings.INVALID_IID_ENROLLMENT,];
      break;
    case IID_PUSH:
      errors = [Strings.PUSH_REJECT,];
      break;
    case CHANGE_PASSWORD:
      errors = [Strings.INVALID_PASSWORD_RESET,];
      break;
    case SECOND_FACTOR:
      errors = [Strings.SECOND_FACTOR_INVALID,];
      break;
    case SELF_SERVICE_START:
    case SELF_SERVICE_END:
      errors = [Strings.INTERNAL_ERROR,];
      break;
    case USERNAME_PASSWORD:
    case SELF_SERVICE_ENROLL:
    default:
      errors = [Strings.INVALID_CREDENTIALS,];
      break;
    }
    break;
  case GetMsgModalityNotEnrolled.asString:
    // logError('Underlying error: ModalityNotEnrolled');
    // fall through
  case GetMsgModalityNotAllowed.asString:
    errorCode === GetMsgModalityNotAllowed.asString && logError('Underlying error: ModalityNotAllowed');
    switch (contextPage) {
    case USERNAME_PASSWORD:
      errors = [Strings.MODALITY_NOT_ALLOWED_OR_ENROLLED,];
      break;
    default:
      errors = [Strings.INVALID_CREDENTIALS,];
      break;
    }
    break;
  case GetMsgUserDisabled.asString:
    // logError('Underlying error: UserDisabled');
    errors = [Strings.USER_DISABLED,];
    break;
  case GetMsgUserExpired.asString:
    // logError('Underlying error: UserExpired');
    errors = [Strings.USER_EXPIRED,];
    break;
  case GetMsgUserLocked.asString:
    // logError('Underlying error: UserLocked');
    errors = [Strings.USER_LOCKED,];
    break;
  case GetMsgUsernameNotUnique.asString:
    // logError('Underlying error: UsernameNotUnique');
    errors = [Strings.USERNAME_NOT_UNIQUE,];
    break;
  case GetMsgUserNotFound.asString:
    // logError('Underlying error: UserNotFound');
    errors = [Strings.USER_NOT_FOUND,];
    break;
  case GetMsgInvalidPhoneNumber.asString:
    // logError('Underlying error: InvalidPhoneNumber');
    errors = [Strings.INVALID_PHONE_NUMBER,];
    break;
  case GetMsgInvalidImprivataIdSerialNumber.asString:
    // logError('Underlying error: InvalidImprivataIdSerialNumber');
    errors = [Strings.INVALID_IID_ENROLLMENT,];
    break;
  case GetMsgApplianceNotConnected.asString:
    // logError('Underlying error: ApplianceNotConnected');
    errors = [Strings.APPLIANCE_NOT_CONNECTED,];
    break;
  case GetMsgWorkflowNotAssigned.asString:
    // logError('Underlying error: WorkflowNotAssigned');
    errors = [Strings.WORKFLOW_NOT_ASSIGNED1, Strings.WORKFLOW_NOT_ASSIGNED2,];
    break;
  case GetMsgWorkflowNotEnabled.asString:
    // logError('Underlying error: WorkflowNotEnabled');
    errors = [Strings.WORKFLOW_NOT_ENABLED1, Strings.WORKFLOW_NOT_ENABLED2,];
    break;
  case GetMsgWorkflowNotAllowed.asString:
    // logError('Underlying error: WorkflowNotAllowed');
    errors = [Strings.WORKFLOW_NOT_ALLOWED1, Strings.WORKFLOW_NOT_ALLOWED2,];
    break;
  case ErrorCodes.TIMEOUT:
    // logError('Timeout error');
    errors = [Strings.SERVER_TIMEOUT,];
    break;
  case ErrorCodes.IID_SERIAL_NUMBER_IN_USE:
    errors = [`${Strings.IID_SERIAL_NUMBER_IN_USE1} ${serialNumber} ${Strings.IID_SERIAL_NUMBER_IN_USE2}`,];
    break;
  case ErrorCodes.AUTH_ON_OTHER_DEVICE:
    errors = [Strings.HELPDESK_VERIFICATION_DETAILS_OTHER_DEVICE,];
    break;
  case null:
    errors = [];
    break;
  case GetMsgInternalError.asString:
    // logError('Underlying error: InternalError');
    // fall through
  default:
    errorCode !== GetMsgInternalError.asString && logError('Underlying error: Unknown');
    errors = [Strings.INTERNAL_ERROR,];
    break;
  }
  return errors;
}
